export class Constants {
    public static UserKey = "picalive.user";
    public static ExperienceListKey = "picalive.experiences";
    public static UrlSignIn = "/login";
}